/**
 * Expose game state to React debug panel.
 * Phaser scenes call these to update the debug overlay.
 * 
 * Usage in Phaser:
 *   (window as any).__henrySetDebug?.({ scene: 'Game', wave: 3, ... })
 */

export function setDebugState(state: {
  scene?: string;
  player?: { x: number; y: number; hp: number; maxHp: number };
  wave?: number;
  enemies?: number;
  timer?: string;
  upgradeOpen?: boolean;
  coins?: number;
  kills?: number;
}) {
  (window as any).__henrySetDebug?.(state);
}